import { render } from "./FirstStart.vue?vue&type=template&id=6086dd63&scoped=true&ts=true"
import script from "./FirstStart.vue?vue&type=script&lang=ts"
export * from "./FirstStart.vue?vue&type=script&lang=ts"

import "./FirstStart.vue?vue&type=style&index=0&id=6086dd63&lang=scss&scoped=true"
import "../styles/native-auth.css?vue&type=style&index=1&id=6086dd63&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6086dd63"]])

export default __exports__